/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Create_AccountInputs */

const en_nav_create_account = /** @type {(inputs: Nav_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activate Your Access`)
};

const fr_nav_create_account = /** @type {(inputs: Nav_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer votre accès`)
};

/**
* | output |
* | --- |
* | "Activate Your Access" |
*
* @param {Nav_Create_AccountInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const nav_create_account = /** @type {((inputs?: Nav_Create_AccountInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Create_AccountInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_create_account(inputs)
	return fr_nav_create_account(inputs)
});